import { type RouterConf, navigate } from 'svelte-mini-router';
import Start from '../../pages/start/App.svelte';
import Login from '../../pages/login/App.svelte';
import Signin from '../../pages/signin/App.svelte';
import Dashboard from '../../pages/dashboard/App.svelte';
import PartnerOnboarding from '../../pages/partnerOnboarding/App.svelte';
import CreativityGenerator from '../../pages/creativityGenerator/App.svelte';
import ReferralLanding from '../../pages/referralLanding/App.svelte';
import NutritionalProfile from '../../pages/settings/pages/nutritionalProfile/App.svelte';
import UserProfile from '../../pages/settings/pages/userProfile/App.svelte';
import Logout from '../../pages/settings/pages/logout/App.svelte';
import Settings from '../../pages/settings/App.svelte';
import Frame from '../../pages/frame/App.svelte';
import configurationPage from '../../pages/settings/pages/configurationPage/App.svelte';
import SpriteTest from '../../pages/spriteTest/App.svelte';
import SsoStart from '../../pages/sso/start/App.svelte';
import SsoOnboarding from '../../pages/sso/onboarding/App.svelte';
import SsoResult from '../../pages/sso/result/App.svelte';
import SsoCompanion from '../../pages/sso/companion/App.svelte';
import SsoTunigi from '../../pages/sso/tunigi/App.svelte';
import { setCurrentPage } from '../swipe';
import { trackScreen } from '@/services/firebase';

export const routerConf: RouterConf = {
    routes: [
        {
            path: '/',
            render: async () => await ({ default: Start })
        },
        {
            path: '/login',
            render: async () => await ({ default: Login })
        },

        {
            path: '/signin',
            render: async () => await ({ default: Signin })
        },
        {
            path: '/dashboard',
            render: async () => await ({ default: Dashboard })
        },

        {
            path: '/partnerOnboarding',
            render: async () => await ({ default: PartnerOnboarding })
        },

        {
            path: '/creativityGenerator',
            render: async () => await ({ default: CreativityGenerator })
        },

        {
            path: '/userProfile',
            render: async () => await ({
                default: UserProfile
            })
        },
        {
            path: '/nutritionalProfile',
            render: async () => await ({
                default: NutritionalProfile
            })
        },
        {
            path: '/settings',
            render: async () => await ({
                default: Settings
            })
        },

        {
            path: '/logout',
            render: async () => await ({ default: Logout })
        },


        {
            path: '/config',
            render: async () => await ({ default: configurationPage })
        },

        {
            path: '/frame/{id}',
            render: async () => await ({
                default: Frame
            })
        },
        {
            path: '/framehtml',
            render: async () => await ({
                default: Frame
            })
        },

        {
            path: '/spriteTest',
            render: async () => await ({ default: SpriteTest })
        },

        // SSO partner onboarding portal — must be before the referral catch-all.
        {
            path: '/{partnerId}/start',
            render: async () => await ({ default: SsoStart })
        },
        {
            path: '/{partnerId}/onboarding',
            render: async () => await ({ default: SsoOnboarding })
        },
        {
            path: '/{partnerId}/result',
            render: async () => await ({ default: SsoResult })
        },
        {
            path: '/{partnerId}/companion',
            render: async () => await ({ default: SsoCompanion })
        },
        {
            path: '/{partnerId}/tunigi',
            render: async () => await ({ default: SsoTunigi })
        },

        // Partner referral landing — /partner/{id} only; old /{referralId} catch-all removed.
        {
            path: '/partner/{referralId}',
            render: async () => await ({ default: ReferralLanding })
        },
    ],
    baseUrl: '/',
};

export function goTo(url: string, params = {}) {
    setCurrentPage(url);
    navigate(url, params);
    trackScreen(url);
}

export function replaceRoute(url: string, params = {}) {
    setCurrentPage(url);
    navigate(url, { ...params, replaceState: 'true' });
}

export async function goToWithTransition(route) {
    document.body.classList.add('page-transition');
    await new Promise((resolve) => setTimeout(resolve, 300));
    goTo(route);
}